<template>
  <div class="home">
    <div class="row">
      <div class="col-6 col-sm-12 z-10">
        <div class="padd padd--bigger">
          <title-comp>
            <h1 class="grey">
              OSER<br> 
              L'ESPOIR<br>
              <span>SAISON</span><br> 
              <span>19-20</span>
            </h1>
          </title-comp>
          
          <img v-in-viewport.once src="/images/home-cover-mobile.jpg" class="rs transition mobile cover-mobile" />

          <div v-in-viewport.once class="transition">
            <p class="marg--p">
              Bienvenue. Sous le titre OSER L’ESPOIR, la saison 2019-2020 se veut une saison de renouveau pour le Grand Théâtre de Genève. Un nouveau directeur général, un bâtiment méticuleusement rendu à une nouvelle jeunesse, et une programmation inédite.
            </p>

            <p class="text--right">
              <a href="" v-on:click.prevent="openPopin" class="link-popin link-popin--home">Voir plus</a>
            </p>
          </div>
        </div>

        <carrousel class="carrousel--right">
          <event v-for="event in events" class="carrousel__item" parallax="false" :event="event" :key="event.title" />
        </carrousel>
      </div>

      <div class="col-6 col-sm-12">
        <div class="desktop">
          <div class="imagewrapper pb-125">
            <parallax>
              <img src="/images/home-cover.jpg" class="rs" />
            </parallax>
          </div>
          <scroll-button />  
        </div>
        
        <div class="rel"><div class="shadowbg shadowbg--1 shadowbg--tl"></div></div>
        <div class="padd">
          <title-comp>
            <h2 class="grey">
              LE<br> NOUVEAU<br>
              <span>GTG</span>
            </h2>
          </title-comp>

          <p v-in-viewport.once class="transition">
            <b>Le Grand Théâtre change de peau.</b><br>
            Rénovation, nouvelle identité graphique, nouvelle saison 2019-20 sous le signe de l’innovation. Prêt·e à le découvrir&nbsp;?
          </p>
          <button-arrow link="/identite#abonnements" css="button--3lines button--3lines2">
            s'abonner<br> à la saison 19-20
          </button-arrow>
          <button-arrow link="/agenda" css="button--3lines">
            découvrir la<br> programmation de<br> la saison 19-20
          </button-arrow>
        </div>
        <parallax factor="100"><div class="textdeco textdeco--left">plage</div></parallax>
      </div>
    </div>
    <div class="row">
      <div class="col-2 desktop"></div>
      <div class="col-4 col-sm-12 padd--mobile rel">
        <div class="shadowbg shadowbg--2 shadowbg--br"></div>
        <div class="marg">
          <title-comp>
            <h2 class="blue size-90">
              DéTENDEZ-<br>
              VOUS,<br>
              <span>VOUS êTES à</span><br>
              <span>LA PLAGE</span>
            </h2>
          </title-comp>
        </div>
      </div>
      <div class="col-1 dekstop"></div>
      <div class="col-4 col-sm-12 padd--mobile">
        <div class="marg">
          <p v-in-viewport.once class="transition">
            <b>Les opéras, les ballets, les récitals, c’est bien…</b><br>
            Mais le monde qui les entoure, c’est encore plus riche. Plongez dans nos grands thèmes et laissez votre esprit vagabonder à travers de nouvelles expériences tout au long de la saison.
          </p> 
          <button-arrow link="/la-plage" css="button--blue">
            découvrir<br class='desktop'> le<br class='mobile'> concept de la plage
          </button-arrow>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
    
    <div class="row marg--bottom big-image">
      <div class="col-10">
        <div class="imagewrapper pb-50">
          <parallax>
            <img v-in-viewport.once src="/images/home-plage.jpg" class="rs transition" />
          </parallax>
        </div>
      </div>
    </div>

    <twitter-feed />
  </div>
</template>

<style lang="scss">
.home{
  .big-image{
    @media #{$bp-sm}{
      margin: 4rem 0 8rem;
    }
  }
  .link-popin{
    margin-top: 2rem;
  }
}
</style>

<script>
import ButtonArrow from '../components/ButtonArrow.vue';
import TwitterFeed from '../components/TwitterFeed.vue';
import ScrollButton from '../components/ScrollButton.vue';
import Carrousel from '../components/Carrousel.vue';
import Event from '../components/Event.vue';
import TitleComp from '../components/TitleComp.vue';
import Parallax from '../components/Parallax.vue';

export default {
  components: {
    ButtonArrow, TwitterFeed, ScrollButton, Carrousel, Event, TitleComp, Parallax
  },
  data() {
    return {
      events: this.$events
    };
  },
  methods: {
    openPopin(){
      this.$store.commit('openPopin', 'home')
    }
  },
  mounted(){
  }
};
</script>
